import { useEffect } from "react";
import { EventClass, EventType } from "../../../../_game/config/Events";
import { __EventDispatcher } from "../../../core";
import "./Popup.style.css";

export interface ModalWindowButtonData {
  text: string;
  showCondition?: boolean;
  onClick?: any;
}

export interface PopupInterface {
  onClose?: any;
  content?: any;
  title: string;
  buttons?: Array<ModalWindowButtonData>;
  timer?: number;
}

const DEFAULT_OPTIONS = {
  title: "Undefined Popup",
  onClose: () => {},
};

const Popup = (_props: PopupInterface) => {
  let props = {
    ...DEFAULT_OPTIONS,
    ..._props,
  };

  useEffect(() => {
    if (_props.timer && _props.timer > 0) {
      // setTimeout(() => {
      //   __EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.CLEAR_POPUP);
      // }, _props.timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="popup-box">
      <div className="box">
        <div className="popup-title">{props.title}</div>
        <div
          className="popup-content"
          dangerouslySetInnerHTML={{ __html: props.content }}
        ></div>
        {props.buttons && (
          <div className="popup-buttons">
            {props.buttons.map((button, _index) => (
              <button
                className="popup-btn"
                key={`ButtonPopup_${_index}`}
                onClick={() => button.onClick()}
              >
                {button.text}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Popup;
